module.exports = __webpack_public_path__ + "img/intagram.91e08df9.svg";